<template>
  <b-container v-if="loaded">
    <b-row>
      <b-col>
        <h1>Outage</h1>
      </b-col>
    </b-row/
    <b-row>
      <b-col>
        <b-row>
          <b-col>
            <b>Lift:</b>
            <router-link :to="'/lifts/' + outage.elevator_id">{{ elevatorName(outage) }}</router-link>
          </b-col>
        </b-row>
      </b-col>

      <b-col>
        <b-row>
          <b-col>
            <b>Started:</b> {{ outageTimeFormatter(outage.started_at) }}
          </b-col>
        </b-row>
      </b-col>

      <b-col v-if="outage.ended_at != '0001-01-01T00:00:00Z'">
        <b-row>
          <b-col>
            <b>Ended:</b> {{ outageTimeFormatter(outage.ended_at) }}
          </b-col>
        </b-row>
      </b-col>

      <b-col v-if="outage.position">
        <b-row>
          <b-col>
            <b>Position:</b> {{ outage.position }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="outage.events && outage.events.length > 0">
      <b-col>
        <b-row>
          <b-col>
            <h3>Events</h3>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-table striped :items="outage.events" :fields="fields"></b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import moment from 'moment';

export default {
  name: 'outage',
  data() {
    return {
      loaded: false,
      outage: {},
      fields: [
        {
          key: 'time',
          label: 'Time',
          sortable: true,
          formatter: (value, key, item) => {
            return moment(item.time).locale('en-gb').calendar();
          }
        },
        { 
          key: 'msg',
          label: 'Description',
          sortable: true,
        },
      ],
    }
  },
  methods: {
  },
  computed: {
  },
  methods: {
    getOutage(id) {
      api.getOutage(id, resp => {
        if(resp.data) {
          this.outage = resp.data;
          this.loaded = true;
        } else {
          this.outage = null;
          this.loaded = false;
        }
      });
    },
    outageTimeFormatter(time) {
      return moment(time).format('YYYY-MM-DD HH:mm');
    },
  },
  created() { 
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
    }

    this.getOutage(this.$route.params.id);
  },
  beforeDestroy() {
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Outage.vue